up.compiler('.mobile_navigation_icon', function(element) {
  const $element = $(element)
  if ($element.is(':visible')) {
    const $navigation = $element.siblings('.account_navigation')
    $element.on('click', function(event) {
      $navigation.toggleClass('hidden')
      event.stopPropagation()
    })
    $(window).click(function() {
      if (!$navigation.hasClass('hidden')) {
        $navigation.addClass('hidden')
      }
    })
  }
})
